import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useAppShellFlags = createFlagsHook<typeof import('./flags.json')>()
